export default __webpack_public_path__ + "static/DSC_0451-7567feb29e34a5c5efb8d04078893ea3.jpg";